import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../store/models/user.model';
import { Store } from '@ngxs/store';
import { Token } from '@angular/compiler/src/ml_parser/lexer';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  user$: Observable<User>;
  token: any;
  region: string;
  u: User;

  constructor(private store: Store) {
    this.user$ = this.store.select(state => state.user.user);
    this.user$.subscribe(u => {
      if (u !== null) {
        this.token = u.token;
        this.region = u.region;
        this.u = u;
      }
    });
  }

  /**
   * 
   */
  hasAutorisation(autorisation:string){
    let ret = false;
    
    let us:User = JSON.parse(sessionStorage.getItem('user'));
    
    us.autorisation.forEach(a=>{
      if(a.code_autorisation === autorisation){
        ret = true;
        return;
      }
    });
    return ret;
  }

  /**
   * 
   */
  getUser() {
    return this.u;
  }

  getToken() {
    return this.token;
  }
  getAccessToken(){
    return this.token.access_token;
  }
  getTokenType(){
    return this.token.token_type;
  }
  getRefreshToken(){
    return this.token.refresh_token;
  }
  getExpiresIn(){
    return this.token.expires_in;
  }
  getRegion() {

    return this.region;
  }

}
